import error from '@js/error';

const ui = [];

error.register(ui);



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/views/error.js